import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  headerAvatar: {
    width: 64,
    height: 64,
    backgroundColor: '#EBF0F2',
    color: '#172024',
    '& .MuiSvgIcon-root': {
      width: 28,
      height: 28,
      fontSize: 28,
    },
  },
  infoCardsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(3),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  infoCardsGridSingle: {
    gridTemplateColumns: '1fr',
  },
  content: {
    paddingBottom: theme.spacing(4),
  },
  headerActionButton: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
    minHeight: 36,
    padding: '6px 16px',
    fontWeight: 600,
  },
  deleteFacility: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(2),
    },
  },
  deleteText: {
    maxWidth: '60%',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.5,
    color: '#6B7C87',
    textAlign: 'left',
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  deleteActionButton: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    width: 'auto',
    minWidth: 'auto',
    maxWidth: 'none',
    height: 'auto',
    minHeight: 36,
    maxHeight: 'none',
    padding: '6px 16px',
    fontWeight: 600,
    flexShrink: 0,
  },
}))
